<app-header [hidden]="loading"></app-header>
<div class="content">
    <router-outlet>
        <div class="loader" *ngIf="loading"></div>
    </router-outlet>
</div>
<app-footer [hidden]="loading"></app-footer>